<template>
  <v-col class="text-center" align-self="center">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn text rounded v-on="on">
          {{ momentumValue }}
          <v-icon right color="orange">mdi-fire</v-icon>
        </v-btn>
      </template>
      <span>Burn Momentum ({{ momentumValue }})</span>
    </v-tooltip>
  </v-col>
</template>

<script>
  export default {
    name: 'FooterMomentum',
    computed: {
      momentumValue() {
        return this.$store.getters['character/momentumCurrent'];
      },
    },
    methods: {
      resetMomentum() {
        this.$store.dispatch('resetMomentum');
      },
    },
  };
</script>
